import {Component, Inject, inject, OnDestroy, Output, EventEmitter} from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms'
import {MatSelectChange} from "@angular/material/select";
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {MatDialog, MAT_DIALOG_DATA,MatDialogRef} from '@angular/material/dialog';
import {UserService} from "../../core/user/services/user.service";
import {IdfSelectDialogComponent} from "./idf-select-dialog/idf-select-dialog.component";


@Component({
  selector: 'app-idf-select',
  templateUrl: './idf-select.component.html',
  styleUrls: ['./idf-select.component.scss']
})
export class IdfSelectComponent implements OnDestroy {
  public showInput = false;
  public idfs: any[] = [];
  @Output() selectedIdf: EventEmitter<any> = new EventEmitter<any>();

  idfForm = this.formBuilder.group({
    idfInput: ['', [Validators.required, Validators.pattern(/^\d{2,7}$/)]]
  });
  isAdmin = false;
  currentlyDisplayedIdf: any;
  private ngUnsubscribe$ = new Subject<boolean>();
  pharmacy = '';

  constructor(
    private formBuilder: FormBuilder,
    protected userService: UserService,
    public dialog: MatDialog,

  ) {
    this.userService.loadAllIdfs()?.pipe(takeUntil(this.ngUnsubscribe$)).subscribe((response: any) => {
      this.idfs = response;
      if (this.idfs?.length) {
        this.currentlyDisplayedIdf = sessionStorage.getItem('idf') ?? this.idfs[0].idf;
        this.pharmacy = this.idfs[0].name;
        this.userService.setPharmacyName(this.idfs[0].name);
        this.userService.setMainIdf(this.idfs[0]);
        this.userService.setSelectedIdf(this.currentlyDisplayedIdf)
        this.isAdmin = this.userService.isAdmin();
        this.showInput = this.userService.isAdmin() || this.currentlyDisplayedIdf === "9999910";
      }
    })
  }

  openIdfSelector() {
    const dialogRef = this.dialog.open(IdfSelectDialogComponent, {
      data: {
        idfs: this.idfs,
        currentIdf: this.currentlyDisplayedIdf,
      },
      disableClose: true,
      panelClass: 'idf-selector-dialog',
      closeOnNavigation: true
    });

    dialogRef.afterClosed().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(result => {
      if(result) {
        this.currentlyDisplayedIdf = result.idf;
        this.userService.setSelectedIdf(this.currentlyDisplayedIdf);
        sessionStorage.setItem('idf', this.currentlyDisplayedIdf);
        this.pharmacy = result.name;
      }
    })
  }

  setIdf($event: MatSelectChange) {
    this.selectedIdf.emit($event.value)
  }

  inputIdf(event: any) {
    const idf = (event.target as HTMLInputElement).value;
    this.userService.setSelectedIdf(idf);
    this.userService.getPharmacyNameByIdf(idf);
  }

  changeIdf(idf: any) {
    this.userService.setSelectedIdf(idf.value)
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next(false);
    this.ngUnsubscribe$.complete();
  }
}
